import isEqual from "lodash/isEqual";
import { createSelector } from "reselect";
import { defaultFormatter } from "util/object";
import { modelsToSelectOptions } from "util/select";
import { sortByProp } from "util/sort-by-prop";

const sortById = sortByProp.bind(null, "id", "desc");
const defaultObject = Object.freeze({});
const defaultArray = Object.freeze([]);

function getById(state, id) {
  const { byId } = state || defaultObject;
  return byId === undefined ? null : byId[id];
}

function findByProperty(propName, value, state) {
  const byId = state.byId || defaultObject;

  const found = Object.values(byId).find((item) => {
    return item[propName] === value;
  });

  return found === undefined ? null : found;
}

function _getAllAsArray(byId) {
  // Sort so it's deterministic output
  return Object.values(byId).sort(sortById);
}

function _getById(state) {
  return state.byId || defaultObject;
}

/*
 * Selector in reselect has a caching size of 1. When the same instance is used
 * by multiple components, caching will fail due to over-written btw components.
 * To avoid this, we use factory method to create individual instance.
 */
function makeGetAllAsArray() {
  return createSelector(_getById, _getAllAsArray);
}

function _getModels(models) {
  return models;
}

function _getSelectOptions(formatter, models) {
  return modelsToSelectOptions(models, formatter);
}

function makeGetSelectOptions(formatter = defaultFormatter) {
  const getSelectOptions = _getSelectOptions.bind(null, formatter);

  return createSelector(_getModels, getSelectOptions);
}

function filterBy(state, filterMethod) {
  const { byId = defaultObject } = state;
  return {
    byId: Object.keys(byId).reduce((acc, key) => {
      const val = byId[key];
      if (filterMethod(key, val)) {
        acc[key] = val;
      }
      return acc;
    }, {}),
  };
}

function filterByProperty(state, property, value) {
  return filterBy(state, (_, v) => v[property] === value);
}

function isStoreEmpty(state) {
  const byId = state.byId || {};

  return !isEqual(byId, {});
}

function isStoreReady(state) {
  return Boolean(state.statusCode);
}

export {
  defaultArray,
  defaultObject,
  filterBy,
  filterByProperty,
  findByProperty,
  getById,
  isStoreEmpty,
  isStoreReady,
  makeGetAllAsArray,
  makeGetSelectOptions,
};
